<div class="card mb-3">
  <section class="m-3">
    <h2 class="h6 fw-bold font-size-sm">
      CDS Approver assignment for agency:
    </h2>
    <p-table #approverdt [value]="cdsApprovers" [columns]="cols" [autoLayout]="true" [responsive]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngFor="let col of columns" [hidden]="!col.visible">
            {{ col.header }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns" [ngSwitch]="col.field" [hidden]="!col.visible">
            <span *ngSwitchCase="'FirstName'">{{rowData.FirstName}} {{rowData.LastName}}</span>
            <span *ngSwitchCase="'DateCDSApproverAssigned'">{{rowData.DateCDSApproverAssigned | utcToLocal:'MM/dd/yyyy'}}</span>
            <span *ngSwitchDefault>{{rowData[col.field]}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            No CDS approver assigned for agency.
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="invalid-value" *ngIf="cdsApprovers.length > 1">
      *There should be only one CDS Approver per agency. 
    </div>
  </section>
  <section class="m-3">
    <h2 class="h6 fw-bold font-size-sm">
      Assign/Re-assign CDS Approver for agency:
    </h2>
    <h6 class="h6 fw-bold font-size-sm">
      <a class="icon-link text-decoration-none" data-bs-toggle="collapse" href="#cdsApproverList" role="button" aria-expanded="true" aria-controls="cdsApproverList" aria-label="Show or hide the CDS approver list table">
        <i title="Show or hide the CDS approver list table" aria-hidden="true" [class]="toggleIconClass"></i>
        <span class="text-body">List of users in agency</span>
      </a>
    </h6>
    <div #cdsApproverPanel id="cdsApproverList" class="collapse show" (hide.bs.collapse)="toggleClass('hide')" (show.bs.collapse)="toggleClass('show')">
      <p-table #userdt [value]="users" [columns]="userListCols" [paginator]="true" [rows]="rows" [autoLayout]="true" [responsive]="true" selectionMode="single" [(selection)]="selectedUser">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns" [hidden]="!col.visible">
              <span class="text-nowrap">{{col.header}}</span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td *ngFor="let col of columns" [ngSwitch]="col.field" [hidden]="!col.visible">
              <span *ngSwitchCase="'AgencyOrganizationName'">{{rowData[col.field]}}</span>
              <span *ngSwitchDefault>{{rowData[col.field]}}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              No users found.
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="d-flex flex-wrap mx-2 mt-2 filter-status">
        <div class="px-2 py-2 font-size-sm"><button type="button" class="btn btn-success" [disabled]="!agency.CDS || !selectedUser" (click)="addCDSApprover()">Assign User as CDS Approver</button></div>
      </div>
    </div>
  </section>
</div>
